
export class MetaProcessExecution {
businessUnitCode: string;
domain: string;
endTime: number | null;
errorMessage: string;
id: number | null;
processCode: string;
processUuid: string;
startTime: number | null;
status: string;
visionCode: string;
}

